import * as React from 'react';
import { DraggableProps } from '../DragAndDrop/Draggable';

export interface SortableListBaseProps extends DraggableProps {
  dataHook?: string;
  insertPosition?: SortableListBaseInsertPosition;
  usePortal?: boolean;
  dragPreview?: boolean;
  items?: object[];
  className?: string;
  contentClassName?: string;
}

export default class SortableListBase extends React.PureComponent<SortableListBaseProps> {}

export type SortableListBaseInsertPosition = 'start' | 'end' | 'any';
